
// --- ХЕЛПЕР КОНФИГУРАЦИИ (ТАБЛИЦА ПРАВИЛ) ---
// Определяет список табов и активный таб по умолчанию
const getHudConfiguration = (role, team, phase, isGhost, lastActionTime, subMode) => {
  const tabs = [];
  let defaultTab = 'draw'; // Фоллбэк

  // 1. ПРИЗРАКИ И ЗРИТЕЛИ
  if (isGhost) {
    // Табы: Миниигра, Чат призраков
    tabs.push({ id: 'minigame', type: 'game', labelKey: 'mafia.hud.tab_minigame' });
    tabs.push({ id: 'chat_ghosts', type: 'chat', labelKey: 'mafia.hud_ghost_chat' });

    // Логика по умолчанию
    if (['draw_mafia', 'night'].includes(phase)) {
      defaultTab = 'minigame';
    } else {
      defaultTab = 'chat_ghosts';
    }
    return { tabs, defaultTab };
  }

  // 2. КОМАНДА МАФИИ (Team 'mafia')
  if (team === 'mafia') {
    // Табы: Смотреть, Рисовать, Действие, Чат мафии
    tabs.push({ id: 'watch', type: 'eye', labelKey: 'mafia.hud.tab_watch' });
    tabs.push({ id: 'draw', type: 'draw', labelKey: 'mafia.hud.tab_draw' });
    // ИЗМЕНЕНИЕ: Добавляем проверку subMode === 'mafia'
    if (subMode === 'mafia') {
        tabs.push({ id: 'action', type: 'action', labelKey: 'mafia.hud.tab_action' });
    }
    tabs.push({ id: 'chat_mafia', type: 'chat', labelKey: 'mafia.hud.tab_chat' });

    // Логика по умолчанию
    if (phase === 'night') defaultTab = 'chat_mafia';
    else if (phase === 'draw_mafia') defaultTab = 'draw';
    else defaultTab = 'watch'; // draw_civilian

    return { tabs, defaultTab };
  }

  // 3. ДОКТОР
  if (role === 'doctor') {
    // Табы:
    // draw_civilian -> Рисование
    // draw_mafia / night -> Действие, Миниигра

    if (phase === 'draw_civilian') {
      tabs.push({ id: 'draw', type: 'draw', labelKey: 'mafia.hud.tab_draw' });
      defaultTab = 'draw';
    }
    else if (['draw_mafia', 'night'].includes(phase)) {
      tabs.push({ id: 'action', type: 'action', iconKey: 'heal', labelKey: 'mafia.hud.tab_action' });
      tabs.push({ id: 'minigame', type: 'game', labelKey: 'mafia.hud.tab_minigame' });

      // Если действие уже совершено, по умолчанию миниигра, иначе действие.
      // Но доктор может вернуться в действие, чтобы изменить выбор.
      defaultTab = lastActionTime ? 'minigame' : 'action';
    }

    return { tabs, defaultTab };
  }

  // 4. ДЕТЕКТИВ
  if (role === 'detective') {
    if (phase === 'draw_civilian') {
      tabs.push({ id: 'draw', type: 'draw', labelKey: 'mafia.hud.tab_draw' });
      defaultTab = 'draw';
    }
    else if (['draw_mafia', 'night'].includes(phase)) {
      // ИСПРАВЛЕНИЕ: Если уже сходил (hasActed), убираем кнопку действия
      if (lastActionTime) {
        // Если сходил, таба действий нет.
        // Если есть активные чаты, они добавятся в основном коде динамически.
        defaultTab = `chat_interrogation`;
   
      } else {
        tabs.push({ id: 'action', type: 'action', iconKey: 'search', labelKey: 'mafia.hud.tab_action' });
        defaultTab = 'action';
      }
    }
    return { tabs, defaultTab };
  }

  // 5. МИРНЫЕ (Остальные)
  if (team === 'town') {
    // Табы:
    // draw_civilian -> Рисование
    // draw_mafia / night -> Миниигра

    if (phase === 'draw_civilian') {
      tabs.push({ id: 'draw', type: 'draw', labelKey: 'mafia.hud.tab_draw' });
      defaultTab = 'draw';
    }
    else if (['draw_mafia', 'night'].includes(phase)) {
      tabs.push({ id: 'minigame', type: 'game', labelKey: 'mafia.hud.tab_minigame' });
      defaultTab = 'minigame';
    }

    return { tabs, defaultTab };
  }

  // Фоллбэк
  return { tabs, defaultTab };
};

const createMafiaSlice = (set, get, ref) => {

  // Инициализация объекта в ref
  ref.mafia = {
    role: null,      // 'mafia' | 'civilian' | 'doctor' | 'detective' | 'spectator'
    team: null,      // 'town' | 'mafia'
    phase: null,     // 'draw_civilian' | 'draw_mafia' | 'voting' | 'discussion' | 'night'
    teammates: [],
    endTime: 0,
    roleSeen: false, // Флаг: видел ли игрок попап с ролью
    spyGrid: {},     // Объект для хранения ссылок на мини-канвасы (для оптимизации рендера шпиона)
    votes: {},       // Данные голосования
    viewMode: 'grid', // 'grid' (наблюдение) | 'canvas' (рисование) | 'chat'
    spyGridScale: 1.0, // зум для сетки (отдельный от основного холста)
    spyGridOffset: { x: 0, y: 0 }, // смещение для сетки {x, y}

    // NEW STRUCTURE
    chats: {}, // Structure: { 'general': { title: 'General', messages: [], unread: 0 }, 'mafia': { ... } }
    activeTab: 'draw', // 'watch', 'draw', 'action', 'minigame', 'chat_general', 'chat_mafia'
    activeRoom: null,
    hasDrawn: false,
    lastActionTime: undefined,
    availableTabs: [], // <--- ДОБАВИТЬ ЭТО ПОЛЕ
    lastTarget: null, // ID игрока, которого нельзя выбрать (для доктора/детектива)
    interrogationWelcomeSeen: false, // Флаг: видел ли игрок приветствие допроса

    revealedWord: null, // <--- ДОБАВИТЬ ЭТО ПОЛЕ
    minigameType: null, // <--- Тип активной мини-игры

    // НОВАЯ СТРУКТУРА СОСТОЯНИЯ НОЧИ
    nightState: {
        // Данные команды мафии
        mafiaState: {
            shootVotes: {},      // { userId: targetId }
            blobTarget: null,    // targetId
            readyForNightEnd: [] // [userId, userId]
        },
        // Мои личные действия (Словарь!)
        // Пример: { 'heal': 'user1', 'check': 'user2', 'mafia_vote': 'user3' }
        myActions: {},

        // Активный допрос
        activeInterrogation: null // { room, initiator, targetId }
    },
  };

  ref.mafia.methods = {

    // Частичное обновление (Реакция на сокет mafia:state_update)
    updateNightState: (payload) => {
        // payload = { nightState: ... }
        if (!payload.nightState) return;

        // Полностью заменяем объект nightState (сервер присылает актуальный snapshot для этого юзера)
        ref.mafia.nightState = payload.nightState;

        // Сайд-эффекты интерфейса
        ref.mafia.lastActionTime = payload.nightState.lastActionTime;
        ref.mafia.methods.updateTabsConfiguration(); 

        // Если начался допрос -> переходим в чат
        if (payload.nightState.activeInterrogation) {
            const room = payload.nightState.activeInterrogation.room;
            ref.mafia.roleSeen = true;
            if (ref.mafia.activeTab !== `chat_${room}`) {
                 ref.mafia.methods.setActiveTab(`chat_${room}`);
            }
        }

        ref.menu.methods.render();
    },

    // Инициализация при загрузке игры
    initMafia: (mafiaPublic) => {
      if (!mafiaPublic) return;

      const game = ref.info.game;

      const myRole = mafiaPublic.role;
      const myTeam = mafiaPublic.team;
      const currentPhase = mafiaPublic.phase;
      const myId = ref.telegram.telegramUserId;
      // Проверка на призрака (спект или мертв)

      const lastActionTime = mafiaPublic.lastActionTime;

      const isGhost = (!myRole && game?.subMode === 'mafia') || (mafiaPublic.alive && mafiaPublic.alive[myId] === false);

      const processedChats = {};
      if (mafiaPublic.chats) {
        for (let room in mafiaPublic.chats) {
          const chat = mafiaPublic.chats[room];
          processedChats[room] = { ...chat };
        }
      }

      // Забираем nightState целиком
      const receivedNightState = mafiaPublic.nightState || {};

      // Мержим с дефолтным, чтобы не было undefined
      const safeNightState = {
          mafiaState: receivedNightState.mafiaState || { shootVotes: {}, blobTarget: null, readyForNightEnd: [] },
          myActions: receivedNightState.myActions || {},
          activeInterrogation: receivedNightState.activeInterrogation || null
      };

      // Конфигурация табов
      const config = getHudConfiguration(myRole, myTeam, currentPhase, isGhost, lastActionTime, game?.subMode);

      let activeTab = config.defaultTab;

      // Флаг просмотра уведомления
      let welcomeSeen = ref.mafia.interrogationWelcomeSeen ?? false;

      let roleSeen = false;

      // Если есть активный допрос
      if (safeNightState.activeInterrogation) {
           // Ставим активным табом чат допроса
           activeTab = `chat_${safeNightState.activeInterrogation.room}`;
           welcomeSeen = false;
           roleSeen = true;
      }

      if (currentPhase === 'draw_mafia' && myRole === 'civilian') {
        activeTab = 'minigame';
        roleSeen = true;
      }

      Object.assign(ref.mafia, {
        role: myRole,
        team: myTeam,
        phase: currentPhase,
        chats: processedChats,
        activeTab: activeTab, // Устанавливаем вычисленный таб
        activeRoom: null, // Will be set by setActiveTab if tab is chat
        hasDrawn: false, // Should be updated from server if user re-joins
        lastActionTime: lastActionTime,
        availableTabs: config.tabs, // СОХРАНЯЕМ СПИСОК ТАБОВ

        endTime: mafiaPublic.endTime,
        teammates: mafiaPublic.teammates || [],
        lastTarget: mafiaPublic.lastTarget, // ID игрока, которого нельзя выбрать

        roleSeen: roleSeen,
        interrogationWelcomeSeen: welcomeSeen, // Применяем вычисленный флаг

        revealedWord: null, // Сбрасываем раскрытое слово
        minigameType: mafiaPublic.minigame || null,

        word: mafiaPublic.word || null,

        definition: mafiaPublic.definition || null,

        // Забираем nightState целиком
        nightState: safeNightState,
      });

      // Вызываем setActiveTab для применения режима просмотра
      if (activeTab) {
          ref.mafia.methods.setActiveTab(activeTab);
      }
      ref.mafia.methods.updateDrawPermission();
      // Сразу применяем настройки отображения слоев
      ref.mafia.methods.updateSpyView();
      
    },

    setActiveTab: (tabKey) => {
        ref.mafia.activeTab = tabKey;
        
        // Map Tab to Internal View Logic
        if (tabKey === 'watch') {
            ref.mafia.viewMode = 'grid';
            ref.mafia.activeRoom = null;
        } else if (tabKey === 'draw') {
            ref.mafia.viewMode = 'canvas';
            ref.mafia.activeRoom = null;
        } else if (tabKey === 'action') {
            ref.mafia.viewMode = 'canvas'; // Action screen overlays canvas
            ref.mafia.activeRoom = null;
        } else if (tabKey === 'minigame') {
            ref.mafia.viewMode = 'canvas'; // Minigame overlays canvas
            ref.mafia.activeRoom = null;
        } else if (tabKey && tabKey.startsWith('chat_')) {
            ref.mafia.viewMode = 'chat';
            // Extract real ID e.g., 'chat_general' -> 'general'
            const realId = tabKey.replace('chat_', ''); 
            ref.mafia.activeRoom = realId;
            ref.mafia.methods.markChatRead(realId);
        } else {
            ref.mafia.viewMode = 'canvas'; // Default fallback
            ref.mafia.activeRoom = null;
        }

        ref.mafia.methods.updateSpyView();
        ref.menu.methods.render();
    },

    markChatRead: (room) => {
        if (ref.mafia.chats[room]) {
            ref.mafia.chats[room].unreadCount = 0;
            set(state => ({ render: state.render + 1 }));
        }
    },

    // Обработка смены фазы (сокета)
    setPhase: (data) => {
      const game = ref.info.game;

      ref.mafia.phase = data.phase;
      ref.mafia.endTime = data.endTime;

      // === ДОБАВЛЕНО: Обновляем тип мини-игры ===
      if (data.minigame !== undefined) {
         ref.mafia.minigameType = data.minigame;
      }
      // ==========================================

      // ИЗМЕНЕНИЕ: Сохраняем раскрытое слово, если оно пришло
      if (data.word) {
        ref.mafia.revealedWord = data.word;
      }
      
      const isGhost = !ref.info.game?.mafiaPublic?.alive?.[ref.telegram.telegramUserId] || ref.mafia.role === 'spectator';

      // ПЕРЕСЧИТЫВАЕМ КОНФИГУРАЦИЮ ДЛЯ НОВОЙ ФАЗЫ
      const config = getHudConfiguration(ref.mafia.role, ref.mafia.team, data.phase, isGhost, ref.mafia.lastActionTime, game?.subMode);

      const currentTab = ref.mafia.activeTab;
      let targetTab = config.defaultTab;

      if (ref.mafia.lastActionTime && config.defaultTab === 'action') {
        targetTab = currentTab;
      }

      // Сохраняем табы
      ref.mafia.availableTabs = config.tabs;

      // Авто-переключение
      ref.mafia.methods.setActiveTab(targetTab);
      ref.mafia.methods.updateDrawPermission();
      ref.mafia.methods.updateSpyView();

      // Показываем уведомление
      let text = '';
      if (data.phase === 'draw_mafia') text = window.t('mafia.phase_notification_mafia');
      else if (data.phase === 'draw_civilian') text = window.t('mafia.phase_notification_civilian');
      else if (data.phase === 'discussion') text = window.t('mafia.phase_notification_discussion');
      else if (data.phase === 'voting') text = window.t('mafia.phase_notification_voting');
      else if (data.phase === 'night') text = window.t('mafia.phase_notification_night');

      if (text) ref.menu.methods.showTemporaryHint(text, { force: true });

      ref.menu.methods.render(); // Обновляем UI
    },

    // Логика блокировки рисования
    updateDrawPermission: () => {
      const { team, phase } = ref.mafia;
      let canDraw = false;

      // ИЗМЕНЕНИЕ: Мафия рисует в мирную фазу, свою фазу И НОЧЬЮ
      if (team === 'mafia' && (
          phase === 'draw_civilian' ||
          phase === 'draw_mafia' ||
          phase === 'night' // <-- Добавлено
      )) {
        canDraw = true;
      }

      // Мирные рисуют только в свою фазу
      if (team === 'town' && phase === 'draw_civilian') {
        canDraw = true;
      }
      ref.info.canDraw = canDraw;
      set({ canDraw });

    },

    // Закрытие попапа роли
    closeRolePopup: () => {
      ref.mafia.roleSeen = true;
      ref.menu.methods.render(); // Перерисовываем, чтобы скрыть попап

      if (ref.mafia.team === 'town') {
        ref.menu.methods.triggerHint('mafia_intro');
      }
    },

    // Метод для обновления статуса рисования
    setHasDrawn: (status) => {
        if (ref.mafia.hasDrawn !== status) {
            ref.mafia.hasDrawn = status;
            ref.menu.methods.render();
        }
    },

    // === ГЛАВНАЯ МАГИЯ: Виртуальные слои ===
    updateSpyView: () => {
        const { info, telegram, convy } = ref;
        const { viewMode } = ref.mafia;
        const myId = telegram.telegramUserId;

        if (!info.game) { return; }

        const allUsers = Object.values(info.game.users || {});
        // Игроки, которых нужно показать (все, кроме меня)
        const others = allUsers.filter(u => String(u.id) !== String(myId));

        // Мой слой 'base'
        const myLayer = convy.methods.getLayer('base');

        if (viewMode === 'canvas') {
            // --- РЕЖИМ РИСОВАНИЯ (CANVAS) ---

            // 1. Показываем мой слой на весь экран
            if (myLayer) {
            myLayer.info.visible = true;
            myLayer.info.scale = 1;
            myLayer.info.offset = {x: 0, y: 0};
            myLayer.info.opacity = 1;
            }
            ref.work.methods.saveUserGameSets({ activeLayerId: 'base' });

            // 2. Скрываем слои других игроков
            others.forEach(u => {
                const l = convy.methods.getLayer(String(u.id));
                l.info.visible = false;
                // Сбрасываем параметры, чтобы при переключении не было глитчей
                l.info.scale = 1;
                l.info.offset = {x: 0, y: 0};
            });

        } else if (viewMode === 'grid') {
            // --- РЕЖИМ НАБЛЮДЕНИЯ (GRID) ---

            // 1. Скрываем мой слой
            if (myLayer) myLayer.info.visible = false;

            const count = others.length;
            if (count === 0) {
               ref.drawing.methods.redraw();
               return;
            }

            // 2. Расчет сетки
            const canvasSize = 800; // Базовый логический размер
            const padding = 20;     // Отступ между ячейками

            // Определяем количество колонок
            let cols = 1;
            if (count >= 2 && count <= 4) cols = 2;
            else if (count > 4) cols = 3;

            const rows = Math.ceil(count / cols);

            // Вычисляем размер одной ячейки (квадратной)
            const availableWidth = canvasSize - (padding * (cols + 1));
            const cellSize = availableWidth / cols;

            // Масштаб для слоя
            const scale = cellSize / canvasSize;

            // Смещение по вертикали, чтобы сетка была по центру экрана
            const totalGridHeight = rows * cellSize + (rows + 1) * padding;
            const startY = (canvasSize - totalGridHeight) / 2;

            // 3. Расстановка слоев
            others.forEach((u, index) => {
                const layer = convy.methods.getLayer(String(u.id));

                layer.info.visible = true;
                layer.info.scale = scale;
                layer.info.opacity = 1;
                layer.info.rotation = 0;

                // Позиция в сетке
                const col = index % cols;
                const row = Math.floor(index / cols);

                // Координаты центра текущей ячейки
                const cellCenterX = padding + col * (cellSize + padding) + cellSize / 2;
                const cellCenterY = startY + padding + row * (cellSize + padding) + cellSize / 2;

                // Центр основного холста (400, 400)
                const mainCenter = canvasSize / 2;

                // Вычисляем смещение от центра холста к центру ячейки
                const targetOffsetX = cellCenterX - mainCenter;
                const targetOffsetY = cellCenterY - mainCenter;

                layer.info.offset = {
                    x: targetOffsetX,
                    y: targetOffsetY
                };
            });
        }
        // viewMode === 'chat' does not affect canvas layers visibility directly here
        // or we could hide everything if chat is full screen overlay, but currently chat is part of content

        ref.drawing.methods.redraw();
    },

    // Метод для ручного переключения (для кнопок в хедере)
    setViewMode: (mode) => {
        // Deprecated in favor of setActiveTab, but keeping for compatibility if called elsewhere
        ref.mafia.viewMode = mode;
        ref.mafia.methods.updateSpyView();
        ref.menu.methods.render();
    },

    // Управление зумом сетки шпиона
    setSpyGridZoom: (scale, offset = null) => {
      ref.mafia.spyGridScale = Math.max(0.1, Math.min(3.0, scale));
      if (offset) {
        ref.mafia.spyGridOffset = offset;
      }
    },

    // Проверка клика (для хука usePointer)
    checkInteraction: () => {
       // Разрешаем зум и пан в режиме сетки, но запрещаем рисование
      //  if (ref.mafia.viewMode === 'grid') return false;
      //  return ref.info.canDraw;

      return true;
    },

    // Добавление сообщения в историю чата
    addChatMessage: (message, room = null) => {
      // Determine target chat ID
      let targetRoom = room;
      if (!targetRoom) {
          // If no room provided, try to guess or use default
          // For now, assume general if not specified, or fallback to 'general'
          // However, messages from server usually don't have room if they are old style
          targetRoom = 'general';
          // If it's a mafia message? Usually server sends separate event or property
          // We can check if message has some property, or just assume general for now
          // If we had message.room from server, use it.
          if (message.room) targetRoom = message.room;
      }
      
      // Ensure chat exists, if not create it (safe fallback)
      if (!ref.mafia.chats[targetRoom]) {
          ref.mafia.chats[targetRoom] = { id: targetRoom, title: targetRoom, messages: [], unreadCount: 0 };
      }
      
      const chat = ref.mafia.chats[targetRoom];

      const exists = chat.messages.find(m =>
          (m.id && m.id === message.id) ||
          (m.isTemp &&
           m.text === message.text &&
           String(m.userId) === String(message.userId) &&
           Math.abs(m.timestamp - message.timestamp) < 60000)
      );

      if (exists) {
          if (exists.isTemp && !message.isTemp) {
              Object.assign(exists, message);
              delete exists.isTemp;
              set(state => ({ render: state.render + 1 }));
          }
          return;
      }

      chat.messages.push(message);
      
      // Increment unread if chat is not active
      if (ref.mafia.activeRoom !== targetRoom && !message.isTemp) {
          chat.unreadCount = (chat.unreadCount || 0) + 1;
           const { info } = ref;
           // Global notification toast
           info.chat.push({
             author: window.t('mafia.chat_author'),
             text: window.t('mafia.chat_text'),
             color: '#d14e4e',
             message: window.t('mafia.chat_notification', { author: message.author, text: message.text }),
             untilTime: Date.now() + 5000
           });
           ref.menu.methods.render();
      }

      set(state => ({ render: state.render + 1 }));
    },

    // 3. Добавить helper updateTabs (если hasActed изменился без смены фазы)
    updateTabsConfiguration: () => {
        const game = ref.info.game;

        const { role, team, phase, lastActionTime } = ref.mafia;
        const isGhost = !ref.info.game?.mafiaPublic?.alive?.[ref.telegram.telegramUserId] || role === 'spectator';

        const config = getHudConfiguration(role, team, phase, isGhost, lastActionTime, game?.subMode);

        // Обновляем список доступных табов
        ref.mafia.availableTabs = config.tabs;

        ref.menu.methods.render();
    },

    // Метод для закрытия оверлея допроса (локально скрываем уведомление)
    dismissInterrogationWelcome: () => {
        ref.mafia.interrogationWelcomeSeen = true;
        ref.menu.methods.render();
    },

  
  };

  return {
    // Новое поле для отслеживания состояния мини-игры
    isMiniGamePlaying: false,
    setMiniGamePlaying: (isPlaying) => set({ isMiniGamePlaying: isPlaying }),

    listenMafia: (socket) => {
      socket.on('mafia:phase', (data) => {
        ref.mafia.methods.setPhase(data);
      });

      socket.on('mafia:new_day_reset', (data) => {
        console.log('🔄 Mafia Full Update received:', data);

        ref.history.methods.clearHistory(); 
        ref.mafia.methods.initMafia(data);

        get().setupCanvasSizes();

        ref.drawing.methods.redraw();
        ref.menu.methods.render();
      });
      // ========================

      // ЕДИНЫЙ ЛИСНЕР ОБНОВЛЕНИЯ СОСТОЯНИЯ
      socket.on('mafia:state_update', (data) => {
          // data = { nightState: ... }
          ref.mafia.methods.updateNightState(data);
      });

      socket.on('mafiaChat', (message) => {
        // Assume message has room or defaults to general
        ref.mafia.methods.addChatMessage(message, message.room);
      });


      // Сохраняем функцию очистки слушателей в ref (если понадобится при размонтировании)
      ref.mafia.methods.mafiaSocketCleanup = () => {
        socket.off('mafia:phase');
        socket.off('mafia:new_day_reset');
        socket.off('mafia:state_update');
        socket.off('mafiaChat');
        socket.off('mafia:action_confirmed');
        socket.off('mafia:interrogation_start');
        socket.off('puzzleUpdate');
      };
    },
  };
};

export default createMafiaSlice;
